export default __webpack_public_path__ + "static/media/cloudy-day-1.213f9a41.svg";